import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../pages/HomeView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/app",
    name: "home",
    component: HomeView,
  },
    {
    path: "/",
    name: "home",
    redirect:'/app'
    // component: HomeView,
  },
  {
    path: "/phonePage",
    name: "phonePage",
    component: () =>
      import(/* webpackChunkName: "about" */ "../pages/phonePage.vue"),
  },
  {
    path: "/userAgreement",
    name: "userAgreement",
    component: () =>
      import(/* webpackChunkName: "about" */ "../pages/userAgreement.vue"),
  },
  {
    path: "/privacyAgreement",
    name: "privacyAgreement",
    component: () =>
      import(/* webpackChunkName: "about" */ "../pages/privacyAgreement.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  // base: process.env.BASE_URL,
  routes,
});

export default router;
